<div class="attachment-move-dialog">
  <div class="attachment-move-dialog__header">
    <div class="left">
      <h3>{{ data.title }}</h3>
    </div>
    <div class="right">
      <button mat-icon-button (click)="closeDialog()" class="p-0">
        <mat-icon style="font-size: 14px; height: 14px; width: 14px">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="attachment-move-dialog__content">
    <div class="app__discovery--header--search--field h-9" style="width: 100%; height: 36px !important; margin-bottom: 12px">
      <div class="app__centered-item w-full h-full" style="padding: 0px 12px">
        <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
        <input
          class="h-full w-full ml-2 border-none outline-none text-[13px]"
          type="text"
          [(ngModel)]="searchText"
          [placeholder]="'Search Vault'"
          (input)="onInputChange($event.target.value)"
        />
        @if (searchText) {
        <span (click)="clearSearchAction()" class="material-icons relative bg-white text-[#898F9E] text-[22px] leading-7 hover:cursor-pointer"
          >clear</span
        >
        }
      </div>
    </div>
    @for (item of vaults_list | filterList : searchText; track item) {
    <div class="vault_folder_no_hover">
      <div class="left">
        <div class="img-container">
          <img [src]="'assets/images/' + item.type + '-small.svg'" alt="icon" />
        </div>
        <h3>{{ item.name | truncateStrPipe : 25 }}</h3>
      </div>
      <div class="right flex">
        <button
          (click)="moveFileTOVault(item)"
          class="rounded border border-solid mt-3 h-[28px] border-[#25508E] w-[56px] bg-transparent text-[#25508E] text-[12px] mb-0 font-semibold hover:bg-[#EBF0FA]"
        >
          Move
        </button>
      </div>
    </div>
    } @if (vaults_list?.length >0 && (vaults_list | filterList : searchText).length == 0) {
    <div class="text-center text-[#898F9E] text-[14px]">No vaults found</div>
    }
  </div>
</div>
